
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/external-experts/claude",
      function () {
        return require("private-next-pages/docs/external-experts/claude.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/external-experts/claude"])
      });
    }
  